import {AfterViewInit, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {UserService} from '../../services/user.service';
import {DiscoverFilterBar, FilterSearch} from '../../../models/filter-search';
import {InfluencerGroup} from '../../../models/influencer-group';
import {ModalService} from '../../services/modal/modal.service';
import {DiscoverService} from '../../services/discover/discover.service';
import {Influencer} from '../../../models/influencer';
import {CampaignInfluencerStatus, CommonConstant, discoverFilterSearchConst} from '../../app.constants';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Location as NgCommonLocation} from '@angular/common';
import {Subscription} from 'rxjs/Subscription';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {CacheService} from '../../services/cache/cache.service';
import {AchooTabsComponent} from '../../core/achoo-tabs/achoo-tabs.component';
import {DiscoverSearchComponent} from './discover-search/discover-search.component';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {Project} from '../../../models/project/project';
import {ObjectUtils} from '../../utils/object.utils';
import {
  ActionSource,
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';
import {DateUtils} from '../../utils/date.utils';
import {TranslateService} from '@ngx-translate/core';
import {PostListComponent} from '../influencer/post-list/post-list.component';
import {CampaignService} from '../../services/campaign/campaign.service';
import {InfluencerGroupsService} from '../influencer-groups/influencer-groups.service';
import {environment} from '../../../environments/environment';

enum DiscoverTab {
  POST = 'posts',
  INFLUENCER = 'influencers'
}

@Component({
  selector: 'discover-page',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.scss']
})
export class DiscoverComponent extends AbstractAchooComponent implements OnDestroy, OnInit, AfterViewInit {

  @ViewChild('InformationNoSearchFilterItemFound')
  public informationNoSearchFilterItemFound: AchooPopupComponent;
  @ViewChild('InformationInfluencerAreSearching')
  public informationInfluencerAreSearching: AchooPopupComponent;
  @ViewChild('bottomBar')
  public bottomBar: ElementRef;
  @ViewChild('discoverTabs') discoverTabs: AchooTabsComponent;
  @ViewChild('ClearFilterWarningPopup') clearFilterWarningPopup: AchooPopupComponent;
  @ViewChild('DiscoverySearchBar') discoverySearchBar: DiscoverSearchComponent;
  @ViewChild('WarningOpenIncompletedStory') warningOpenIncompletedStory: AchooPopupComponent;
  @ViewChild('DiscoverPostList') discoverPostList: PostListComponent;
  public discoverFilterBar: DiscoverFilterBar;
  public influencerGroupId: number;
  public influencerGroup: InfluencerGroup = new InfluencerGroup();

  public campaignList: any[];
  public influencerGroupList: any[];

  public scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
  public scrollUpDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE_UP;
  public throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE_100;
  public currentFilterSearch: FilterSearch = new FilterSearch();
  private currentPageIndex: number = CommonConstant.START_PAGE_INDEX;
  private isShowBottomBar = false;

  public tabKey: string;

  /** these flag are using for pre-loader
   * isFetchingNextInfluencers -> using when fetching the next result. Do not perform a next pre-loader when next result is fetching
   * isWaitingNextInfluencers -> when user want to see the next result, but the fetching of next result is not completed. This flag will be enabed.
   **/
  public isFetchingNextInfluencers = false;
  public isWaitingNextInfluencers = false;
  public isFetchingNextPosts = false;
  public isWaitingNextPosts = false;
  // caching pre-loaded data of next result
  public storedDiscoverInfluencers: Array<Influencer> = [];
  public storedDiscoverPosts: Array<Influencer> = [];
  // current influencer result list
  public discoverInfluencers: Array<Influencer> = [];
  // number of total matched influencers
  public totalDiscoverInfluencer: number;
  // selected preview influencer list
  public selectedPreviewInfluencers: Array<Influencer> = [];
  // current post result list
  public discoverPosts: Array<Influencer> = [];
  // number of total matched posts
  public totalDiscoverPost: number;
  // selected preview post list
  public selectedPreviewPosts: Array<Influencer> = [];
  // influencer search Subscription
  public fetchDiscoverInfluencerSubcription: Subscription;
  // use for preload influencer
  public preloadDiscoverInfluencerSubcription: Subscription;
  // list campaign to add to post
  public campaignListToPost: Array<any> = [];
  // stored current filter search to detect changed on switch tab
  public storedFilterSearch: FilterSearch;
  private lastSortValues: Array<any>;

  public showWarningSearchMessage = true;
  public searchRunning = false;
  public missingRequiredFilters = true;

  public activeBottomBar;
  private currentActiveAccount: number;

  // keep current offset
  private currentOffset: number;
  private isRenderedPostList = false;
  private _storyIcompleteMessage: string;
  private env = environment;

  private isLoadingCampaignList = false;
  private isLoadingGroupList = false;
  private isLoadingProjectList = false;

  constructor(
      private referenceDataService: ReferenceDataService,
      protected userService: UserService,
      private discoverService: DiscoverService,
      private modalService: ModalService,
      private router: Router,
      private location: NgCommonLocation,
      private placeholderService: PlaceholderVisibilityService,
      private campaignService: CampaignService,
      private influencerGroupService: InfluencerGroupsService,
      private cacheService: CacheService,
      private activatedRoute: ActivatedRoute,
      private eventTracker: EventTrackerService,
      private translate: TranslateService,
      private ngZone: NgZone
    ) {
    super(userService);
    // This is default groupId to display overview of influencer
    this.influencerGroupId = 0;
    this.discoverFilterBar = new DiscoverFilterBar();
    this.discoverFilterBar.countries = this.referenceDataService.countries;
    this.discoverFilterBar.platforms = this.referenceDataService.platforms.filter(platform => this.env.activePlatforms.find(activePlatform => platform.name.toLowerCase() === activePlatform));
    this.discoverFilterBar.topics = this.referenceDataService.activeTopics;
    this.discoverFilterBar.industries = this.referenceDataService.verticals;
    this.discoverFilterBar.genders = CommonConstant.GENDERS;
    this.currentFilterSearch.orderBy = 'latest';
    // get discover posts and filters search from cached
    if (this.cacheService.has(CommonConstant.DISCOVER_TAB)) {
      this.cacheService.get(CommonConstant.DISCOVER_TAB).subscribe((data) => {
        this.tabKey = data;
        this.showWarningSearchMessage = false;
        this.missingRequiredFilters = false;
        this.replaceTabState(this.tabKey);
      });
    } else {
      const currentTab = this.activatedRoute.snapshot.data.activeTab;
      this.replaceTabState(currentTab);
    }
    this.discoverService.moveOutDiscoverSubject.subscribe((res) => {
      // don't anything if discover page doesn't active
      if (!this.discoverService.isActiveDiscoverPage) {
        return;
      }
      if (res && this.activeBottomBar === 'inactive') {
        this.activeBottomBar = null;
      }
      if (!res) {
        if (!this.isLoadingGroupList) {
          this.loadGroupList(this.userService.getCompanyId());
        }
        if (!this.isLoadingCampaignList) {
          this.loadCampaignList(this.userService.getCompanyId());
        }
        if (!this.isLoadingProjectList) {
          this.loadListProject(this.userService.getCompanyId());
        }
      }
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.discoverService.activeDiscoverPage();
    this.loadListProject(this.companyId, this.triggerSearchByProjectList.bind(this));
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    // unsubscribe all subscriptions before destroying component
    this.cancelPendingSearchRequest();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.ngZone.runOutsideAngular(() => {
      if (this.discoverService.isAllowToCacheScrollPosition) {
        this.cacheService.set(CommonConstant.DISCOVER_SCROLL_TOP, document.documentElement.scrollTop);
      }
    });
  }

  public loadListProject(companyId, callback?) {
    this.isLoadingProjectList = true;
    this.cacheService.get(`all_projects_of_advertiser_${companyId}`,
      this.userService.getAllProjectOfAdvertiser()).subscribe((res: any) => {
      this.isLoadingProjectList = false;
      if (!res || !res.data) {
        return;
      }
      const listProject: Project[] = res.data.map((project) => ({
        id: project.id,
        name: project.name,
        countries: project.projectCountries.map(item => item.country.id),
        keywords: project.projectKeywords.map(item => item.keyword)
      }));
      this.discoverFilterBar.projects = listProject;
      if (callback) {
        callback();
      }
    }, (err) => {
      this.isLoadingProjectList = false;
    });
  }

  afterAddNewProjectFromBottombar(evt) {
    const cloneFilters = ObjectUtils.deepClone(this.discoverFilterBar);
    cloneFilters.projects.push(evt);
    this.discoverFilterBar = cloneFilters;
  }

  private triggerSearchByProjectList() {
    const listProject = this.discoverFilterBar.projects;
    // stop immediately if no project availabel
    if (!Array.isArray(listProject) || listProject.length === 0) {
      return;
    }

    // set the first project as default search criteria for freemium user
    if (this.userService.isFreeUser()) {
      // set the first project as the default selection project
      const firstNoneEmptyProject = this.findFirstNoneEmptyProject(listProject);
      if (!firstNoneEmptyProject) {
        return null;
      }
      const keywords = firstNoneEmptyProject.keywords.map(item => item.keyword);
      const countries = firstNoneEmptyProject.countries;
      this.discoverySearchBar.countriesOfProject = countries;
      this.discoverySearchBar.keywordsOfProject = keywords;

      this.currentFilterSearch.projects = [firstNoneEmptyProject.id];
      this.currentFilterSearch.mentions = keywords;
      this.currentFilterSearch.countries = countries;

      // keep track the discovery search criteria to compare
      if (this.discoverySearchBar) {
        this.discoverySearchBar.previousFilterCriteria = ObjectUtils.deepClone(this.currentFilterSearch);
      }
      // start discover search by project
      this.onSearchDiscoverData(this.currentFilterSearch);
    }
  }

  private canStartLoadingDiscoverDataFromServer(tabKey) {
    if (tabKey === DiscoverTab.INFLUENCER) {
      return !this.cacheService.has(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER);
    } else {
      return !this.cacheService.has(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST);
    }
  }

  // handle Change Account from User Menu (companyId)
  companyChangeCallback(companyId) {
    // reset current data and cancel request
    this.cancelPendingSearchRequest();
    // update Tab state
    this.updateTabState();
    this.missingRequiredFilters = true;
    this.discoverInfluencers = [];
    this.storedDiscoverInfluencers = [];
    this.discoverPosts = [];
    this.storedDiscoverPosts = [];
    this.selectedPreviewPosts = [];
    this.selectedPreviewInfluencers = [];
    this.totalDiscoverPost = 0;
    this.totalDiscoverInfluencer = 0;
    this.lastSortValues = [];
    // reset current filter search
    this.currentFilterSearch.projects = [];
    this.currentFilterSearch.influencers = [];
    this.currentFilterSearch.mentions = [];
    // reset project list
    this.discoverFilterBar.projects = [];

    // load campaign list
    this.currentActiveAccount = companyId;
    this.loadCampaignList(companyId);

    // load list influencer group
    this.loadGroupList(companyId);

    this.discoverService.getInfluencerGroupListSideBarMenu(companyId).subscribe((res: any) => {
      this.discoverFilterBar.influencers = res;
    });

    // load list of project of current user
    this.loadListProject(this.companyId, this.triggerSearchByProjectList.bind(this));
  }

  private loadCampaignList(companyId) {
    if (!companyId) {
      return;
    }
    this.isLoadingCampaignList = true;
    this.campaignService.getCampaignShortListForCompany(companyId).subscribe((res: any) => {
      this.campaignList = res.filter(campaignItem => campaignItem.status !== CampaignInfluencerStatus.ARCHIVED).map(
        (campaign) => ({
          id: campaign.id,
          name: campaign.name,
          brief: campaign.brief
        })
      );
      this.campaignListToPost = this.campaignList;
      this.isLoadingCampaignList = false;
    }, (err) => {
      this.isLoadingCampaignList = false;
    });
  }

  private loadGroupList(companyId) {
    if (!companyId) {
      return;
    }
    this.isLoadingGroupList = true;
    this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe((res: any) => {
      this.influencerGroupList = res.map(group => ({
        id: group.id,
        name: group.name,
        description: group.description
      }));
      this.isLoadingGroupList = false;
    }, (err) => {
      this.isLoadingGroupList = false;
    });
  }

  private findFirstNoneEmptyProject(listProject) {
    return listProject.find(p => Array.isArray(p.keywords) && p.keywords.length > 0);
  }

  public beforeActiveBottomBar(bottomBarHeight?) {
    this.activeBottomBar = 'active';
  }

  public closeBottonBar(evt) {
    if (evt.isReloadInfluencerList) {
      this.reloadDiscoverInfluencerList();
    }
    this.activeBottomBar = 'inactive';
  }

  public clearSelection(activeTab) {
    if (activeTab === DiscoverTab.INFLUENCER) {
      this.selectedPreviewInfluencers = [];
    } else {
      this.selectedPreviewPosts = [];
    }
  }

  public showClearFilterWarningPopup() {
    this.modalService.openInCenter(this.clearFilterWarningPopup);
  }

  public clearSearchResultAndFilter() {
    // clear search result
    this.cancelPendingSearchRequest();
    this.discoverInfluencers = [];
    this.discoverPosts = [];
    this.totalDiscoverInfluencer = 0;
    this.totalDiscoverPost = 0;
    this.lastSortValues = [];
    // clear cache
    this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST);
    this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER);
    // reset filter
    this.currentFilterSearch = new FilterSearch();
    this.missingRequiredFilters = true;
    this.updateTabState();
    this.hideAlertPopupMessage();
    // update activity filter UI
    this.discoverySearchBar.hasFilterActivity = false;
    this.discoverySearchBar.resetActivityFilters();
    this.discoverySearchBar.resetAudienceFilters(true);
    this.discoverySearchBar.resetInterestFilters(true);
  }

  onInvalidSearchCriteria() {
    this.missingRequiredFilters = true;
    this.discoverInfluencers = [];
    this.storedDiscoverInfluencers = [];
    this.discoverPosts = [];
    this.totalDiscoverPost = 0;
    this.totalDiscoverInfluencer = 0;
    this.storedDiscoverPosts = [];
    this.lastSortValues = [];
    this.updateTabState();
  }

  /**
   * trigger search when changing search criteria
   * @param {FilterSearch} searchCriteria
   */
  onChangeSearchCriteria(searchCriteria: FilterSearch) {
    // clear cache data
    this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER);
    this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST);
    this.onSearchDiscoverData(searchCriteria);
  }

  /**
   * Search discover data on filter change
   * @param filterSearch
   */
  onSearchDiscoverData(filterSearch: FilterSearch) {
    this.isRenderedPostList = false;
    // reset offset
    filterSearch.offset = 0;
    filterSearch.limit = 0;
    filterSearch.period = discoverFilterSearchConst.period;
    // compute offset and limit
    this.computeNextResultLimitAndOffset(filterSearch);
    // remove warning message
    this.missingRequiredFilters = false;
    // update search criteria
    this.currentFilterSearch = filterSearch;
    // cancel the pending search request before executing the new one
    this.cancelPendingSearchRequest();
    // perform a search request
    if (this.tabKey === DiscoverTab.INFLUENCER) {
      // clear up the previous data
      this.discoverInfluencers = [];
      this.storedDiscoverInfluencers = [];
      // perform search request
      this.searchDiscoverInfluencer(filterSearch, false);
    } else {
      // clear up the previous data
      this.discoverPosts = [];
      // perform search request
      this.searchDiscoverPost(filterSearch, false);
    }
    // segment track search discover action
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.DISCOVER,
    {
      type: Page.DISCOVER
    },
    {
      action: UserActionType.SEARCH,
      source: ActionSource.PAGE,
      ...filterSearch
    },
     undefined,
    {
      type: ActivePages.DISCOVER
    });
  }

  onScrollDown() {
    // prevent infinite load when active route is not Discover
    if (!this.discoverService.isActiveDiscoverPage) {
      return;
    }
    if (this.currentFilterSearch && !this.discoverService.isScrollingToPreviousPosition) {
      if (this.tabKey === DiscoverTab.INFLUENCER) {
        this.currentPageIndex++;
        this.fetchDiscoverInfluencersFromCaching(this.currentFilterSearch);
      } else if (this.tabKey === DiscoverTab.POST) {
        this.isRenderedPostList = false;
        this.currentPageIndex++;
        this.fetchDiscoverPostsFromCaching(this.currentFilterSearch);
      }
    }
  }

  afterRenderPostList() {
    this.isRenderedPostList = true;
  }

  onSelectedInfluencer(influencer: Influencer) {
    if (influencer.selected) {
      const existedItems = this.selectedPreviewInfluencers.filter((item) => item.influencer_id === influencer.influencer_id);
      if (existedItems.length === 0) {
        influencer.previewed = true;
        this.selectedPreviewInfluencers.push(influencer);
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.DISCOVER, {
          id: influencer.influencer_id,
          name: influencer.influencer_name,
          type: TargetType.INFLUENCER
        }, {
          action: UserActionType.SELECTION,
          source: ActionSource.PAGE,
        }, undefined, {
          type: ActivePages.DISCOVER,
        });
      }
    } else {
      // remove unselected item
      this.selectedPreviewInfluencers = this.selectedPreviewInfluencers.filter(
        (item) => item.influencer_id !== influencer.influencer_id
      );
    }
    if (this.isShowBottomBar) {
    }
  }

  onPreviewBottomBarOpen(isOpen: boolean) {
    this.isShowBottomBar = isOpen;
  }

  onSelectedPost(post) {
    const existedItems = this.selectedPreviewPosts.filter((item) => item.url_hash === post.url_hash);
    if (existedItems.length === 0) {
      post.selected = true;
      post.previewed = true;
      this.selectedPreviewPosts.push(post);
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.DISCOVER, {
        id: post.url_hash,
        name: post.title,
        type: TargetType.POST
      }, {
        action: UserActionType.SELECTION,
        source: ActionSource.PAGE,
      }, undefined, {
        type: ActivePages.DISCOVER,
      });
    }
  }

  reloadDiscoverInfluencerList() {
    this.onSearchDiscoverData(this.currentFilterSearch);
  }

  /**
   * @param filterSearch
   * preload the next result for the next request
   * because the performance of dicover is too slow
   * we need to perform an ahead request to preload the data. Then when user scroll down to the end of page
   * They don't need to wait for fetching next result.
   */
  preloadDataForDiscoverInfluencer(filterSearch: FilterSearch) {
    this.computeNextResultLimitAndOffset(filterSearch);
    this.searchDiscoverInfluencer(filterSearch, true);
  }

  fetchDiscoverInfluencersFromCaching(filterSearch: FilterSearch) {
    this.discoverInfluencers = this.discoverInfluencers.concat(this.storedDiscoverInfluencers);
    // clear store
    this.storedDiscoverInfluencers = [];
    // update current offset
    this.currentOffset = filterSearch.offset + filterSearch.limit;
    this.filterPreviewedItemAsSelected(DiscoverTab.INFLUENCER);
    // if the current result is loaded, start loading the next result
    if (!this.isFetchingNextInfluencers) {
      this.preloadDataForDiscoverInfluencer(filterSearch);
    } else {
      // if the next result is loading, waiting for the next result
      this.isWaitingNextInfluencers = true;
      this.placeholderService.show(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
    }

  }

  /**
   * @param filterSearch
   * preload the next result for the next request
   * because the performance of dicover is too slow
   * we need to perform an ahead request to preload the data. Then when user scroll down to the end of page
   * They don't need to wait for fetching next result.
   */
  preloadDataForDiscoverPost(filterSearch: FilterSearch) {
    this.computeNextResultLimitAndOffset(filterSearch);
    this.searchDiscoverPost(filterSearch, true);
  }

  fetchDiscoverPostsFromCaching(filterSearch: FilterSearch) {
    if (this.storedDiscoverPosts.length === 0 && !this.isFetchingNextPosts) {
      this.isRenderedPostList = true;
    }
    this.discoverPosts = this.discoverPosts.concat(this.storedDiscoverPosts);
    this.storedDiscoverPosts = [];
    // update current offset
    this.currentOffset = filterSearch.offset + filterSearch.limit;
    this.filterPreviewedItemAsSelected(DiscoverTab.POST);
    if (!this.isFetchingNextPosts) {
      this.preloadDataForDiscoverPost(filterSearch);
    } else {
      // if the next result is loading, waiting for the next result
      this.isWaitingNextPosts = true;
      this.placeholderService.show(CommonConstant.DISCOVER_POST_LIST_HOLDER);
    }
  }

  hideAlertPopupMessage() {
    this.modalService.close();
  }

  replaceTabState(tabKey: string) {
    if (!tabKey) {
      this.tabKey = DiscoverTab.INFLUENCER;
    } else {
      this.tabKey = tabKey;
    }
    let queryParams;
    if (this.userService.getCompanyId()) {
      queryParams = Object.assign({}, this.activatedRoute.snapshot.queryParams, {activeAccount: this.userService.getCompanyId()});
    } else {
      queryParams = Object.assign({}, this.activatedRoute.snapshot.queryParams);
    }
    const url = this.router.createUrlTree(['/discover', this.tabKey], {
      queryParams: queryParams
    });
    this.location.replaceState(url.toString());
    if (this.canStartLoadingDiscoverDataFromServer(this.tabKey)) {
      this.onSearchDiscoverData(this.currentFilterSearch);
      this.storedFilterSearch = Object.assign({}, this.currentFilterSearch);
    }
  }

  updateTabState() {
    if (this.discoverTabs) {
      this.discoverTabs.delayUpdate();
    }
  }

  orderDiscoverList(orderField) {
    if (this.currentFilterSearch && !this.missingRequiredFilters && !this.compareCurrentFilterWithPreviousFilter()) {
      this.currentFilterSearch.orderBy = orderField;
      this.onChangeSearchCriteria(this.currentFilterSearch);
    }
  }

  openIncompletedStoryWarning(post) {
    const hourDiff = DateUtils.computeTimeDiffInHour(new Date(post.date), new Date());
    if (hourDiff > 24) {
      this._storyIcompleteMessage = this.translate.instant('story.error.incompleted_over_24h');
    } else {
      this._storyIcompleteMessage = this.translate.instant('story.error.incompleted');
    }
    this.modalService.open(this.warningOpenIncompletedStory, null, false);
  }

  private compareCurrentFilterWithPreviousFilter() {
    return JSON.stringify(this.currentFilterSearch) === JSON.stringify(this.storedFilterSearch);
  }

  private searchDiscoverPost(filterSearch: FilterSearch, preloadData: boolean) {
    // should not show placeholder when preloading data
    if (preloadData) {
      this.isFetchingNextPosts = true;
      this.preloadDiscoverInfluencerSubcription = this.discoverService.searchPosts(filterSearch)
        // update the catching data with preloaded data	        // update the catching data with preloaded data
        .subscribe((res) => {
          this.isFetchingNextPosts = false;
          // update the total result post and pagination data
          this.totalDiscoverPost = res.totalPosts;
          this.updateSearchAfter(res.lastSortValues);

          if (this.isWaitingNextPosts) {
            // update search result for current discover list, filter duplicates
            // TODO: Remove this hacky solution
            const nextResult = res.posts.filter(i => !this.discoverPosts.find(d => d.urlHash === i.urlHash));
            this.discoverPosts = this.discoverPosts.concat(nextResult);
            this.isWaitingNextPosts = false;
            this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
            this.preloadDataForDiscoverPost(filterSearch);
          } else {
            this.storedDiscoverPosts = res.posts;
          }
        }, (err) => {
          this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
        });
    } else {
      this.showWarningSearchMessage = false;
      this.searchRunning = true;
      this.updateSearchAfter([]);
      // show placeholder when fetching data
      this.placeholderService.show(CommonConstant.DISCOVER_POST_LIST_HOLDER);

      // make the search
      this.fetchDiscoverInfluencerSubcription = this.discoverService.searchPosts(filterSearch)
        .subscribe((res) => {
          this.showWarningSearchMessage = true;
          this.searchRunning = false;
          // update current offset
          this.currentOffset = filterSearch.offset + filterSearch.limit;

          // update search result for current discover list, filter duplicates
          // TODO: Remove this hacky solution
          const nextResult = res.posts.filter(i => !this.discoverPosts.find(d => d.urlHash === i.urlHash));
          this.discoverPosts = this.discoverPosts.concat(nextResult);
          // update Tab state
          this.updateTabState();

          // filter seleted item already in the previewed list
          this.filterPreviewedItemAsSelected(DiscoverTab.POST);
          this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);

          // Set result count and pagination values
          this.totalDiscoverPost = res.totalPosts;
          this.updateSearchAfter(res.lastSortValues);
          this.cacheService.set(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST, true);

          this.preloadDataForDiscoverPost(filterSearch);
        }, (err) => {
          this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
        });
    }
  }

  private searchDiscoverInfluencer(filterSearch: FilterSearch, preloadData: boolean) {
    // should not show placeholder when preloading data
    if (preloadData) {
      this.isFetchingNextInfluencers = true;
      this.preloadDiscoverInfluencerSubcription = this.discoverService.searchInfluencers(filterSearch)
        // update the catching data with preloaded data
        .subscribe((res) => {
          this.isFetchingNextInfluencers = false;
          // update total result and pagination data
          if (res.totalInfluencers && res.lastSortValues) {
            this.totalDiscoverInfluencer = res.totalInfluencers;
            this.updateSearchAfter(res.lastSortValues);
          }

          if (this.isWaitingNextInfluencers) {
            // update search result for current discover list, filter duplicates
            // TODO: Remove this hacky solution
            const nextResult = res.influencers.filter(i => !this.discoverInfluencers.find(d => d.id === i.id));
            this.discoverInfluencers = this.discoverInfluencers.concat(nextResult);

            this.isWaitingNextInfluencers = false;
            this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);

            // Set result count and pagination values
            if (res.totalInfluencers && res.lastSortValues) {
              this.preloadDataForDiscoverInfluencer(filterSearch);
            }
          } else {
            this.storedDiscoverInfluencers = res.influencers;
          }
        }, (err) => {
          this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
        });
    } else {
      // mark search as running
      this.searchRunning = true;
      this.showWarningSearchMessage = false;
      this.updateSearchAfter([]);

      // show placeholder when fetching data
      this.placeholderService.show(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);

      // make the search
      this.fetchDiscoverInfluencerSubcription = this.discoverService.searchInfluencers(filterSearch)
        .subscribe((res) => {
          this.showWarningSearchMessage = true;
          this.searchRunning = false;

          // update search result for current discover list, filter duplicates
          // TODO: Remove this hacky solution
          const nextResult = res.influencers.filter(i => !this.discoverInfluencers.find(d => d.id === i.id));
          this.discoverInfluencers = this.discoverInfluencers.concat(nextResult);

          // update Tab state
          this.updateTabState();

          // filter seleted item already in the previewed list
          this.filterPreviewedItemAsSelected(DiscoverTab.INFLUENCER);
          this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);

          // Set result count and pagination values
          if (res.totalInfluencers && res.lastSortValues) {
            this.currentOffset = filterSearch.offset + filterSearch.limit;
            this.totalDiscoverInfluencer = res.totalInfluencers;
            this.updateSearchAfter(res.lastSortValues);
            this.preloadDataForDiscoverInfluencer(filterSearch);
          }
          this.cacheService.set(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER, true);
        }, (err) => {
          this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
        });
    }
  }

  /**
   * Update pagination values
  */
  private updateSearchAfter(lastSortValues) {
    this.lastSortValues = lastSortValues;
    this.currentFilterSearch.searchAfter = [];
    if (this.lastSortValues != null && this.lastSortValues.length > 0) {
      this.currentFilterSearch.searchAfter = this.lastSortValues;
    }
  }

  /**
   * Filter preview item was selected
   * Set that item as selected to avoid select the same influencer in the next search
   */
  private filterPreviewedItemAsSelected(tabKey: string) {
    if (this.selectedPreviewInfluencers.length > 0 && tabKey === DiscoverTab.INFLUENCER) {
      this.selectedPreviewInfluencers.map((item) => Object.assign({}, item, {
        selected: this.filterSelectedDiscoverInfluencer(item.influencer_id)
      }));
    }
    if (this.selectedPreviewPosts.length > 0 && tabKey === DiscoverTab.POST) {
      this.selectedPreviewPosts.map((item) => Object.assign({}, item, {
        selected: this.filterSelectedDiscoverPost(item.influencer_id)
      }));
    }
  }

  private filterSelectedDiscoverInfluencer(influencerId: number) {
    const existedItems = this.discoverInfluencers.filter((influencer) => influencer.influencer_id === influencerId);
      return existedItems.length > 0;
  }
  private filterSelectedDiscoverPost(influencerId: number) {
    const existedItems = this.discoverPosts.filter((influencer) => influencer.influencer_id === influencerId);
    return existedItems.length > 0;
  }

  private cancelPendingSearchRequest() {
    if (this.fetchDiscoverInfluencerSubcription) {
      //  hide loader
      this.placeholderService.hideImmediately(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
      this.placeholderService.hideImmediately(CommonConstant.DISCOVER_POST_LIST_HOLDER);
      this.fetchDiscoverInfluencerSubcription.unsubscribe();
    }
    if (this.preloadDiscoverInfluencerSubcription) {
      this.preloadDiscoverInfluencerSubcription.unsubscribe();
    }
  }

  private computeNextResultLimitAndOffset(filterSearch: FilterSearch) {
    const currentOffset = filterSearch.offset || 0;
    const currentLimit  = filterSearch.limit || 0;
    const nextOffset = currentOffset + currentLimit;
    const maxResultPerSearch = this.userService.maxResultPerSearch;
    if (!maxResultPerSearch) {
      filterSearch.limit = discoverFilterSearchConst.limit;
      filterSearch.offset = nextOffset;
    } else {
      const totalRemainingResult = maxResultPerSearch - nextOffset;
      const limit = totalRemainingResult > discoverFilterSearchConst.limit ?
        discoverFilterSearchConst.limit : totalRemainingResult;
      filterSearch.limit = limit;
      filterSearch.offset = nextOffset;
    }
  }

  get shouldShowSubscriptionWarning() {
    if (!this.isRenderedPostList && this.tabKey === DiscoverTab.POST) {
      return false;
    }
    const maxResultPerSearch = this.userService.maxResultPerSearch;
    const totalResult = document.getElementsByClassName('grid-item').length;
    let reachedLimitation = false;
    if (this.currentOffset) {
      reachedLimitation = (this.currentOffset === maxResultPerSearch);
    }

    return maxResultPerSearch && !Number.isNaN(totalResult) && maxResultPerSearch <= totalResult
      && reachedLimitation && !this.searchRunning && !this.missingRequiredFilters;
  }

  get maxResultPerSearch() {
    return this.userService.maxResultPerSearch;
  }

  get totalDiscoveryResult() {
    if (this.tabKey === DiscoverTab.POST) {
      return this.totalDiscoverPost;
    } else {
      return this.totalDiscoverInfluencer;
    }
  }

  get totalDisplayPost() {
    const maxDisplayResult = this.userService.maxResultPerSearch;
    if (maxDisplayResult && maxDisplayResult < this.totalDiscoverPost) {
      return maxDisplayResult;
    } else {
      return this.totalDiscoverPost;
    }
  }

  get totalDisplayInfluencer() {
    const maxDisplayResult = this.userService.maxResultPerSearch;
    if (maxDisplayResult && maxDisplayResult < this.totalDiscoverInfluencer) {
      return maxDisplayResult;
    } else {
      return this.totalDiscoverInfluencer;
    }
  }

  get storyIncompleteMessage() {
    return this._storyIcompleteMessage;
  }

  get target() {
    return this.currentFilterSearch && this.currentFilterSearch.audienceFilters.length > 0 ? 'discover' : null;
  }

  trackByFn(index, item) {
    return item.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/discover/discover.component.ts